import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { Button, Column, Icon, Table } from '@tencent/spaui';

import { RPCFactory } from '../../../../utils/RequestUtil';
import BreakDialog from './dialogs/fieldBreak';

import ABulkMiniDialog from '../../businessSetting/ABulkMiniDialog';

import useDialog from '../../../hooks/useDialog';
import useFeedback from '../../../hooks/useFeedback';
import useDeleteDialog from '../../../hooks/useContentDialog';

import FeedBackDialog from '../../../common/feedback';
import PrivilegeCode from '../../../../consts/PrivilegeCode';

const table = (props) => {
  const canEditFieldSplitting = window.pageProps.privileges.includes(
    PrivilegeCode.LEADS_FIELD_SPLITTING_EDIT.getCode(),
  );

  const [datalist, setDatalist] = useState([]);
  const [flag, setFlag] = useState(0);
  const [deleteId, setDeleteId] = useState('');
  const [target, setTarget] = useState(null);
  const feedbackHooks = useFeedback();
  const deleteConfirmHooks = useDeleteDialog({ showDialog: false });

  const { showDialog, setShowDialog, model, showAsEditModel, showAsAddModel, onClose, isEdit, editItem } = useDialog({
    showDialog: false,
  });

  useEffect(() => {
    RPCFactory.leadsFieldSplitting.getAll().done((data) => {
      setDatalist(data.entities);
    });
  }, [flag]);

  const columnOperatorRender = useCallback((type, name, value, data) => {
    // 目前操作列中仅有写操作，如果没有写权限则不展示操作列
    if (!canEditFieldSplitting) {
      return;
    }
    if (type == 'head') {
      return <span>操作</span>;
    }
    return (
      <div>
        {canEditFieldSplitting && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              onEdit(e, data.fieldSplittingId, data);
            }}
            className="a-link-primary"
          >
            修改
          </a>
        )}
        {canEditFieldSplitting && (
          <a
            style={{ cursor: 'pointer' }}
            onClick={(e) => {
              onConfirm(e, data.fieldSplittingId);
            }}
            className="a-link-primary"
          >
            删除
          </a>
        )}
      </div>
    );
  }, []);

  const concatFields = (item) => {
    let res = item.splittedFieldName1;

    if (item.splittedFieldName2.length > 0) {
      res = `${res};${item.splittedFieldName2}`;
    }

    if (item.splittedFieldName3.length > 0) {
      res = `${res};${item.splittedFieldName3}`;
    }

    if (item.splittedFieldName4.length > 0) {
      res = `${res};${item.splittedFieldName4}`;
    }

    return res;
  };
  const columnSplittedFieldRender = useCallback((type, name, value, data) => {
    if (type == 'head') {
      return <span>拆解后字段名称</span>;
    }
    const label = concatFields(data);
    return <div>{label}</div>;
  }, []);

  const handleReload = useCallback(() => {
    setFlag(flag + 1);
  });

  const onAdd = () => {
    showAsAddModel();
  };

  const onEdit = (event, id, item) => {
    showAsEditModel(item);
  };

  const onConfirm = (e, id) => {
    deleteConfirmHooks.setShow(true);
    setDeleteId(id);
    setTarget(e.target);
  };

  const onDelete = () => {
    deleteConfirmHooks.setShow(false);
    RPCFactory.leadsFieldSplitting
      .delete({
        fieldSplittingId: deleteId,
      })
      .done((data) => {
        feedbackHooks.showSuccessTip('删除成功');
        handleReload();
      })
      .fail((code, msg) => {
        feedbackHooks.showErrorTip(msg);
      });
  };

  const handleSubmit = useCallback(
    (data) => {
      if (isEdit()) {
        RPCFactory.leadsFieldSplitting
          .update(data)
          .done((data) => {
            handleReload();
            setShowDialog(false);
          })
          .fail((code, msg) => {
            feedbackHooks.showErrorTip(msg);
          });
      } else {
        RPCFactory.leadsFieldSplitting
          .add(data)
          .done(() => {
            handleReload();
            setShowDialog(false);
          })
          .fail((code, msg) => {
            feedbackHooks.showErrorTip(msg);
          });
      }
    },
    [model],
  );

  const getEmptyTable = () => (
    <div className="datalist empty">
      <i className="empty-bg"></i>
      <p>暂无配置数据</p>
    </div>
  );

  return (
    <Fragment>
      {canEditFieldSplitting && (
        <div className="panel-hd-right">
          <Button displayType="primary" onClick={onAdd}>
            <Icon type="add" />
            新建配置
          </Button>
        </div>
      )}
      {datalist.length > 0 ? (
        <div className="datalist">
          <Table data={datalist}>
            <Column name="originalFieldName">原始字段名</Column>
            <Column name="splittedFieldName" render={columnSplittedFieldRender}>
              拆解后字段名称
            </Column>
            <Column name="createdTime">创建时间</Column>
            <Column name="operation" render={columnOperatorRender}>
              操作
            </Column>
          </Table>
        </div>
      ) : (
        getEmptyTable()
      )}
      {showDialog ? (
        <BreakDialog
          show={showDialog}
          handleClose={onClose}
          onSubmit={handleSubmit}
          onCancel={onClose}
          model={model}
          editItem={editItem}
        />
      ) : null}
      <FeedBackDialog {...feedbackHooks} />
      <ABulkMiniDialog
        show={deleteConfirmHooks.show}
        onSubmit={onDelete}
        onCancel={deleteConfirmHooks.onClose}
        width={'280px'}
        eventTarget={target}
        eventTargetPlacement={'left'}
        title={''}
      >
        <div className="confirmbox confirmbox-del">
          <div className="content">
            <p className="tt">确定删除该配置？</p>
            <p className="des">删除后不可恢复，平台不再自动转换销售数据。</p>
          </div>
        </div>
      </ABulkMiniDialog>
    </Fragment>
  );
};

export default table;
